export const isFile = (input: any) => 'File' in window && input instanceof File
